import React from 'react'

import ericssonLogo from '../../assets/images/company-logos/ericsson.svg'
import ageasLogo from '../../assets/images/company-logos/ageas.svg'
import wortenLogo from '../../assets/images/company-logos/worten.svg'
import pfizerLogo from '../../assets/images/company-logos/pfizer.svg'
import nosLogo from '../../assets/images/company-logos/nos.svg'
import sonaeLogo from '../../assets/images/company-logos/sonae.svg'
import { getEnterpriseAIContent } from '../../constants/enterpriseAIContent'

const LOGO_ASSETS = {
  ericsson: ericssonLogo,
  ageas: ageasLogo,
  worten: wortenLogo,
  pfizer: pfizerLogo,
  nos: nosLogo,
  sonae: sonaeLogo,
}

const EnterpriseAILogoStrip = ({ lang }) => {
  const { logoStrip } = getEnterpriseAIContent(lang)
  const logos = [
    { key: 'ericsson', alt: 'Ericsson', width: 62, height: 54 },
    { key: 'ageas', alt: 'Ageas', width: 102, height: 41 },
    { key: 'worten', alt: 'Worten', width: 102, height: 21 },
    { key: 'pfizer', alt: 'Pfizer', width: 102, height: 42 },
    { key: 'nos', alt: 'NOS', width: 84, height: 46 },
    { key: 'sonae', alt: 'Sonae', width: 102, height: 19 },
  ]

  const renderTrack = (suffix = '') => (
    <div className="enterprise-ai-logos__track" aria-hidden={suffix ? true : undefined}>
      {logos.map(logo => (
        <img
          key={`${logo.key}${suffix}`}
          className="enterprise-ai-logos__logo"
          src={LOGO_ASSETS[logo.key]}
          alt={suffix ? '' : logo.alt}
          width={logo.width}
          height={logo.height}
          loading="lazy"
          decoding="async"
        />
      ))}
    </div>
  )

  return (
    <section className="enterprise-ai-logos" aria-label={logoStrip.label}>
      <div className="content container enterprise-ai-logos__inner">
        <p className="enterprise-ai-logos__label">{logoStrip.label}</p>
        <div className="enterprise-ai-logos__marquee">
          <div className="enterprise-ai-logos__marquee-inner">
            {renderTrack()}
            {renderTrack('-dup')}
          </div>
        </div>
      </div>
    </section>
  )
}

export default EnterpriseAILogoStrip
